import React, { useEffect } from "react";
import { Container } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import GameHeader from "../components/GameHeader";
import { useGameContext } from "../../../state/game/context";
import { useStatsContext } from "../../../state/stats/context";
import commonStyles from "../../common/styles/Common.styles";
import NavigationTabPanel from "../../season/components/NavigationTabPanel";
import BoxScoreContainer from "./BoxScoreContainer";
import IndividualStatsContainer from "./IndividualStatsContainer";
import ParticipatingPlayersContainer from "./ParticipatingPlayersContainer";

const GameStatsContainer = () => {
	const commonClasses = commonStyles();

	const { state, getBoxScore } = useStatsContext();
	const boxScore = state.boxScore();

	const { state: gameState } = useGameContext();
	const game = gameState.game();

	useEffect(getBoxScore, [game]);

	const getTabItems = () => {
		const tabItems = [];

		tabItems.push({
			label: "Box Score",
			tab: "boxscore",
			component: <BoxScoreContainer boxScore={boxScore} />
		});

		tabItems.push({
			label: "Individual Stats",
			tab: "individual",
			component: <IndividualStatsContainer boxScore={boxScore} />
		});

		tabItems.push({
			label: "Participants",
			tab: "participants",
			component: <ParticipatingPlayersContainer boxScore={boxScore} />
		});

		return tabItems;
	};

	return (
		<>
			<GameHeader
				title="Game Reports"
				description="See statistics for the current game."
			/>
			<Box className={commonClasses.infoContainer}>
				<Container fullHeight>
					<NavigationTabPanel items={getTabItems()} />
				</Container>
			</Box>
		</>
	);
};

export default GameStatsContainer;
